export const AGENCY_EARN_RATE = 0.12;

export const estimateAgencyEarn = (
  clientPrice: number | null
): number | null => {
  if (clientPrice == null) return null;
  return Math.round(clientPrice * AGENCY_EARN_RATE);
};

export const sumClientEstimate = (
  prices: Array<number | null | undefined>
): number => prices.reduce<number>((total, price) => total + (price ?? 0), 0);
